<template lang="pug">
  .profile-page__main
    .profile-page__body
      .manager-shifts-registry
        .manager-shifts-registry__button
          router-link.button.button_paint-main--transparent(
          :to="`/pages/manager/shifts/create/`"
          ) Создать смену
        .manager-shifts-registry__table
          manager-shifts-registry-scroll-fix-table(
          :tab-data="tableData"
          :tab-head="tableHead"
          @on-delete-shift="onDeleteShift"
          )
        .manager-shifts-registry__pagination
          pagination(
          :total-count="paginationTotalCount"
          :page-limit="paginationPageLimit"
          :current-page="paginationCurrentPage"
          @on-button-click="onPaginationButtonClick"
          )

</template>

<script>

import {mapActions} from "vuex";
import ManagerShiftsRegistryScrollFixTable from "./components/ManagerShiftsRegistryScrollFixTable";
import ConfirmModal from "../../../../../components/modals/ConfirmModal";
import Pagination from "../requests/components/Pagination";
export default {
  name: "ManagerShiftsRegistry",
  components: {Pagination, ConfirmModal, ManagerShiftsRegistryScrollFixTable},
  data() {
    return {
      tableHead: [
        {
          title: "Смена"
        },
        {
          title: "Лагерь"
        },
        {
          title: "Даты проведения"
        },
        {
          title: "Всего мест"
        },
        {
          title: "Количество свободных мест"
        }
      ],
      tableData: [],
      paginationPageLimit: 30,
      paginationTotalCount: 0,
      paginationCurrentPage: 1
    };
  },
  methods: {
    ...mapActions(["getShifts", "deleteShift"]),
    deletion(id) {
      this.deleteShift(id).then(res => {
        if (res.status === 204) {
          const index = this.tableData.findIndex(item => {
            return item.id === id;
          });
          this.tableData.splice(index, 1);
        } else if (res.status === 400) {
          let errorText;
          if (res.data[0].code === 18) {
            errorText = "В данную смену была подана заявка. Удаление смены невозможно. Отклоните заявку в выбранную смену и повторите попытку удаления квоты.";
          } else {
            errorText = res.data[0].message;
          }
          this.$root.$emit("onShowErrorModal", {
            text: errorText
          });
        }
      });
    },
    onDeleteShift(shift) {
      this.$root.$emit("onShowConfirmModal", {
        text: "При удалении данной смены все квоты данной смены удалятся. Продолжить?",
        buttonConfirmFunc: {
          func: this.deletion,
          params: [shift.id]
        }
      });
    },
    onPaginationButtonClick(button) {
      this.getData(button - 1);
      this.paginationCurrentPage = button;
    },
    getData(offset = 0) {
      this.$root.$emit("on-show-preloader");
      const filter = {
        params: {
          limit: this.paginationPageLimit,
          offset: offset * this.paginationPageLimit
        }
      };
      this.getShifts(filter).then(res => {
        this.paginationTotalCount = res.count;
        this.tableData = res.results;
        this.$root.$emit("on-hide-preloader");
      });
    }
  },
  created() {
    this.$root.$emit("on-show-preloader");
  },
  mounted() {
    this.getData();
  }
};
</script>
